webpackJsonp([58],{

/***/ "+1Vd":
/***/ (function(module, exports) {

module.exports = {"zhCN":{"phrase":{"project":"工程","export":"导出","exportthispage":"导出此页","exportall":"导出所有","create":"新建","importbyfile":"通过文件导入","movefilehere":"文件拖动到此处,或","clicktoupload":"点击上传","importbydongle":"通过软件狗导入","refresh":"刷新","search":"搜索","advancedsearch":"高级搜索","name":"名字","number":"编号","type":"类型","maxlock":"最大锁数量","maxuser":"最大用户数量","action":"动作","detail":"详细信息","copy":"复制","config":"配置","description":"描述","validperiod":"有效期","activationtime":"开始时间","expirytime":"截止时间","ok":"确定","cancel":"取消","key":"钥匙","registerkey":"注册钥匙","logoutkey":"注销钥匙","lock":"锁","createregisterkey":"制作注册钥匙","createlogoutkey":"制作注销钥匙","dongle":"软件狗","createprofessionaldongle":"制作专业版软件狗","createenterprisedongle":"制作企业版软件狗","more":"更多","createblankkey":"制作空白钥匙","readkey":"读钥匙","readdongle":"读软件狗","cleandongle":"清理软件狗","official":"正式","evaluation":"评估","unknwon":"未知","version":"版本号","id":"ID","groupid":"组ID","mac":"MAC","keyType":"钥匙类型","license":"许可证","userkeytype":"用户钥匙","settingkeytype":"设置钥匙","registerkeytype":"注册钥匙","auditkeytype":"事件钥匙","constructionkeytype":"施工钥匙","emergencykeytype":"应急钥匙","blacklistkeytype":"挂失钥匙","verifykeytype":"锁号钥匙","tracekeytype":"追溯钥匙","logoutkeytype":"注销钥匙","blankkeytype":"空白钥匙","auxiliarykeytype":"辅助钥匙","advancedkeytype":"辅读钥匙","createtime":"创建时间","createemergencykey":"制作应急钥匙","createversionkey":"制作版本钥匙","createtracekey":"制作追溯钥匙","back":"上一步","next":"下一步","logoutlock":"注销锁","registerlock":"注册锁","licensecode":"许可证码","viewlicensecode":"查看许可证码","viewlicense":"查看许可证","createlicensecode":"生成许可证码","updatelicensecode":"更新许可证码","used":"已使用","available":"可用","status":"状态","expire":"超期","logoutdongle":"注销软件狗","logoutkeywithoutcodes":"注销钥匙(无需验证)","publickey":"公钥","template":"模板","blekey":"蓝牙钥匙","nfckey":"NFC钥匙","mininfckey":"迷你NFC钥匙","defaultperiod":"默认周期(日)","templatename":"模板名","delete":"删除","inputpassword":"输入密码","upgradedongle":"升级软件狗","select":"选择","lastweek":"前一周","lastmonth":"前一个月","last3month":"前三个月","quickSelect":"快速选择","disable":"停用","enable":"启用","resetpassword":"重置密码","account":"账号","role":"角色","phone":"手机号","email":"邮箱","administrator":"管理员","projectoperator":"工程操作员","recordoperator":"记录操作员","billoperator":"账单操作员","localeoperator":"现场操作员","productionoperator":"生产操作员","qualityoperator":"品质操作员","unknown":"未知","oldpassword":"旧密码","newpassword":"新密码","confirmpassword":"确认新密码","changepassword":"修改密码","loginwhitelist":"登录白名单","fixedpublicIP":"固定的公网IP地址","add":"增加","disbaled":"不可用","report":"日志","eventtype":"事件类型","eventtime":"事件时间","edit":"编辑","login":"登录","projectname":"工程名","professional":"专业版","enterprise":"企业版","createprodongle":"制作专业版软件狗","createentdongle":"制作企业版软件狗","register":"注册","logout":"注销","simplefsu":"简易动环","registertime":"注册时间","factory":"出厂记录","normalfsu":"通用动环","oldblekey":"旧蓝牙钥匙","blelock":"蓝牙锁","terminalType":"终端类型","terminalFactory":"终端厂商","terminalModel":"终端型号","terminalSerialNumber":"终端序列号","terminalName":"终端名称","belongCity":"归属地市","belongCounty":"归属区县","deviceTechnicalManager":"设备技术主管","deviceTechnicalManagerPhoneNumber":"设备技术主管联系电话","technicalSupport":"技术支撑人员","technicalSupportPhoneNumber":"技术支撑人员联系电话","bleName":"蓝牙名","imei":"IMEI","imsi":"IMSI","edittime":"编辑时间","operator":"运营商","cntt":"中国电信","cmcc":"中国移动","cucc":"中国联通","firstRegisterTime":"首次注册时间","use":"使用记录","bill":"账单","operation":"操作","basicInfo":"基本信息","siteInfo":"站点信息","deviceInfo":"设备信息","picture":"图片","sitename":"站点名","address":"地址","map":"地图","save":"保存","myLocation":"我的位置","battery":"电池","deviceTime":"设备时间","temperature":"温度","disarm":"撤防","deployment":"布防","cellId":"基站ID","cellIP":"基站IP","ip":"IP","port":"端口","rsrq":"RSRQ","sinr":"SINR","networkInfo":"网络信息","gradienter":"水平","waterlogging":"水浸","shake":"震动","armInfo":"告警信息","normal":"正常","alarm":"告警","deviceName":"设备名","mask":"掩码","gateway":"网关","apn":"APN","password":"密码","dialNumber":"拨号号码","gprsSwitch":"GPRS开关","server":"服务器","mode":"模式","tcp":"TCP","udp":"UDP","ai":"AI","di":"DI","open":"开","close":"关","controlboard":"控制板","powerboard":"电源板","expandboard":"扩展板","changedonglelimit":"修改上限","userlimit":"用户上限","locklimit":"锁上限","backupsetting":"备份设置","backupinterval":"备份间隔","backuptime":"备份时间","everydayat":"每天的","everyweekat":"每周的","everymonthat":"每月的","lastbackuptime":"最近备份时间","nextbackuptime":"下次备份时间","backup":"备份","recover":"还原","reset":"重置","monday":"周一","tuesday":"周二","wednesday":"周三","thursday":"周四","friday":"周五","saturday":"周六","sunday":"周日","device":"设备","keytype":"钥匙类型","slm":"Software License Manager","sdk":"SDK","language":"语言","zhCN":"简体中文","enUS":"English","dateformat":"日期格式","help":"帮助","signout":"退出","system":"系统","database":"数据库","callboard":"公告","return":"返回","superadministrator":"超级管理员","task":"任务","nbpanellock":"NB面板锁","onu":"光交","lid":"井盖","alreadyunbind":"已解绑","alreadybind":"已绑定","error":"错误","internaloperator":"内部操作员","nbiot":"NBIOT","all":"所有","takeoffline":"解绑","productnumber":"生产编号","chinesename":"中文名","englishname":"英文名","file":"文件","lastversion":"最新版本","lastedittime":"最近更新时间","chinesechangelog":"中文更新说明","englishchangelog":"英文更新说明","download":"下载","newclock":"新C锁","hardwareversion":"硬件版本号","softwareversion":"软件版本号","producttime":"生产时间","hotspot":"热点","networkmac":"网络Mac地址","model":"型号","exportkeydata":"导出钥匙数据","progress":"进度","newdlock":"新D锁","backupkeep":"备份保留时间","oneweek":"1周","onemonth":"1个月","threemonth":"3个月","oneyear":"1年","forever":"永远","doormanagermain":"门禁主板","doormanagerreader":"门禁读头","doormanager":"门禁","writekeyfactorynumber":"设置钥匙出厂编号","keyfactorynumber":"钥匙出厂编号","invoice":"发票","invoiceprefix":"发票编号前缀","invoicecompany":"发票公司名","price":"价格","date":"日期","consignee":"收货人","nameandspecification":"品名和规格","card":"卡","readcard":"读卡","registercard":"注册卡","createstandalonemanagecard":"制作Standalone管理卡","createstandalonelogoutcard":"制作Standalone注销卡","blankruncylinder":"空转型内胆","createresetcard":"制作重置卡","cardtype":"卡类型","resetcard":"重置卡","opencard":"开门卡","blankcard":"空白卡","settingcard":"设置卡","constructioncard":"工程卡","blacklistcard":"挂失卡","whitelistcard":"解挂卡","agecard":"老化卡","managecard":"管理卡","logoutcard":"注销卡","cabinetlock":"机柜锁","restartkey":"重启钥匙","sharekey":"共享钥匙","factoryId":"厂家编号","specified":"指定","importantparameter":"重要参数","systemcode":"系统码","locksmithcode":"锁匠码","encryptedcodes":"加密的系统码与锁匠码","plaincodes":"明文系统码与锁匠码","registercode":"注册码","iv":"偏移量","tool":"工具","encryptanddecrypt":"加解密","algorithm":"算法","defaultpublickey":"默认公钥","plaintext":"明文","encrypttext":"密文","encrypt":"加密","decrypt":"解密","plaintextformat":"明文格式","changelog":"更新说明","fileoperator":"文件操作员","title":"标题","content":"内容","haveread":"已读","unread":"未读","view":"查看","keyholdermap":"钥匙管理箱图","keyholder":"钥匙管理箱","relateddevicecount":"关联设备数量","pincodepanel":"密码盘","keycode":"牙花","padnumber":"平板编号","tasktime":"任务时间","upload":"上传","testnewcdlock":"测试用新CD锁","pincodedlock":"密码D锁","abandon":"废弃","confirm":"确认"},"message":{"savesucceed":"保存成功.","savefail":"保存失败.","emptyvalue":"请检查是否有必填项为空.","filetypeerror":"文件类型错误,请选择后缀名为xlsx的文件.","registersdkfail":"注册SDK失败.","upgradedonglefail":"升级软件狗失败.","registersdksucceed":"注册SDK成功.版本号为","upgradedonglesucceed":"升级软件狗成功.","registersdktimeout":"注册SDK超时,请检查SDK服务是否正在运行.","sdkinvalid":"SDK无效,请安装SDK并确认其已运行.","professionaldonglelimit":"专业版软件狗最大锁数量不能超过3000.","registerkeysucceed":"注册钥匙成功.","registerkeyfail":"注册钥匙失败.","logoutkeysucceed":"注销钥匙成功.","logoutkeyfail":"注销钥匙失败.","createregisterkeysucceed":"制作注册钥匙成功.","createregisterkeyfail":"制作注册钥匙失败.","createlogoutkeysucceed":"制作注销钥匙成功.","createlogoutkeyfail":"制作注销钥匙失败.","createdonglesucceed":"制作软件狗成功.","createdonglefail":"制作软件狗失败.","createblankkeysucceed":"制作空白钥匙成功.","createblankkeyfail":"制作空白钥匙失败.","readkeyfail":"读钥匙失败.","readdonglefail":"读软件狗失败.","cleandonglesucceed":"清理软件狗成功.","cleandonglefail":"清理软件狗失败.","createlogfail":"新建日志失败.","upgradesdk":"请升级SDK.","createmergencykeyfail":"制作应急钥匙失败.","createtracekeysucceed":"制作追溯钥匙成功.","creatversionkeyfail":"制作版本钥匙失败.","createtracekeyfail":"制作追溯钥匙失败.","registerlockfail":"注册锁失败.","insertlock":"请将钥匙插入锁1次.","locknotbelongtoproject":"该锁部署于此工程.","locknotdefault":"该锁不是出厂设置.","registerkeyfirstly":"请先注册钥匙.","clicknext":"请点击下一步.","usesamekey":"请使用在步骤一使用的那把钥匙.","readkeyeventfail":"读取钥匙事件失败.","registerlocksucceed":"注册锁成功.","logoutlockfail":"注销锁失败.","logoutlocksucceed":"注销锁成功.","createlicensecodesucceed":"生成许可证码成功.","createlicensecodefail":"生成许可证码失败.","updatelicensecodesucceed":"更新许可证码成功.","updateLicensecodefail":"更新许可证码失败.","viewlicensecodefail":"查看许可证码失败.","viewlicensefail":"查看许可证失败.","logoutdonglesucceed":"注销软件狗成功.","logoutdonglefail":"注销软件狗失败.","deletesucceed":"删除成功.","deletefail":"删除失败.","beginlaterthanend":"开始时间不能晚于截止时间.","locklimit3000":"最大锁数量不能超过3000.","passworddifferent":"两次输入的新密码不同.","ipinvalid":"IP地址不合法.","newpasswordshoulddifferent":"新密码不能与旧密码相同.","parsefail":"解析失败.","backupsucceed":"备份成功.","backupfail":"备份失败.","getbackuplistfail":"获取备份列表失败.","recoversucceed":"还原成功.","recoverfail":"还原失败.","getbackupsettingfail":"获取备份设置失败.","changedonglelimitfail":"修改软件狗上限失败.","changedonglelimitsucceed":"修改软件狗上限成功.","plsinputaccount":"请输入账号.","plsinputpassword":"请输入密码.","connectserverfail":"连接服务器失败.","loginfail":"登录失败.","updateSuccess":"更新成功.","updateFail":"更新失败.","useadminkey":"请使用管理钥匙.","imeilengtherror":"IMEI长度必须为15.","searchfailed":"搜索失败.","cannotfinddevice":"未找到该设备.","takeofflinesucceed":"解绑设备成功.","takeofflinefailed":"解绑设备失败.","fileExceed":"文件数量超出.","chooseuploadfile":"请选择文件上传.","readkeyeepromfail":"导出钥匙数据失败.","writekeyfactorynumberfail":"设置钥匙出厂编号失败.","writekeyfactorynumbersucceed":"设置钥匙出厂编号成功.","createinvoicefail":"创建发票失败.","readcardsucceed":"读卡成功.","readcardfail":"读卡失败.","registercardsucceed":"注册卡成功.","registercardfail":"注册卡失败.","logoutcardsucceed":"注销卡成功.","logoutcardfail":"注销卡失败.","createstandalonemanagecardsucceed":"制作Standalone管理卡成功.","createstandalonemanagecardfail":"制作Standalone管理卡失败.","createstandalonelogoutcardsucceed":"制作Standalone注销卡成功.","createstandalonelogoutcardfail":"制作Standalone注销卡失败.","createresetcardsucceed":"制作重置卡成功.","createresetcardfail":"制作重置卡失败.","restartkeysucceed":"重启钥匙成功.","restartkeyfail":"重启钥匙失败.","countnot0":"用户或锁数量不能为0.","encryptsucceed":"加密成功.","encryptfail":"加密失败.","decryptsucceed":"解密成功.","decryptfail":"解密失败.","keyfactorynumberalreadyexist":"钥匙出厂编号已存在.","getdatafail":"获取数据失败.","createemergencykeysucceed":"制作应急钥匙成功.","createemergencykeyfail":"制作应急钥匙失败.","passworderror":"密码错误.","confirmAbandonKeyHolder":"确定废弃钥匙管理箱?","abandonFail":"废弃失败.","abandonSucceed":"废弃成功."}},"enUS":{"phrase":{"project":"Project","export":"Export","exportthispage":"Export This Page","exportall":"Export All","create":"Create","importbyfile":"Import By File","movefilehere":"Move file here, or","clicktoupload":"Click to upload","importbydongle":"Import By Dongle","refresh":"Refresh","search":"Search","advancedsearch":"Advanced Search","name":"Name","number":"Number","type":"Type","maxlock":"Maximum Lock","maxuser":"Maximum User","action":"Action","detail":"Details","copy":"Copy","config":"Config","description":"Description","validperiod":"Valid Period","activationtime":"Activation Time","expirytime":"Expiry Time","ok":"OK","cancel":"Cancel","key":"Key","registerkey":"Register Key","logoutkey":"Logout Key","lock":"Lock","createregisterkey":"Create Register Key","createlogoutkey":"Create Logout Key","dongle":"Dongle","createprofessionaldongle":"Create Professional Dongle","createenterprisedongle":"Create Enterprise Dongle","more":"More","createblankkey":"Create Blank Key","readkey":"Read Key","readdongle":"Read Dongle","cleandongle":"Clean Dongle","official":"Official","evaluation":"Evaluation","unknwon":"Unknown","version":"version","id":"ID","groupid":"Group ID","mac":"MAC","keyType":"Key Type","license":"License","userkeytype":"User Key","settingkeytype":"Setting Key","registerkeytype":"Register Key","auditkeytype":"Audit Key","constructionkeytype":"Construction Key","emergencykeytype":"Emergency Key","blacklistkeytype":"Blacklist Key","verifykeytype":"Verify Key","tracekeytype":"Trace Key","logoutkeytype":"Logout Key","blankkeytype":"Blank Key","auxiliarykeytype":"Auxiliary Key","advancedkeytype":"Advanced Key","createtime":"Create Time","createemergencykey":"Create Emergency Key","createversionkey":"Create Version Key","createtracekey":"Create Trace Key","back":"Back","next":"Next","logoutlock":"Logout Lock","registerlock":"Register Lock","licensecode":"License Code","viewlicensecode":"View License Code","viewlicense":"View License","createlicensecode":"Create License Code","updatelicensecode":"Update License Code","used":"Used","available":"Available","status":"Status","expire":"Expire","ip":"IP","logoutdongle":"Logout Dongle","logoutkeywithoutcodes":"Logout Key(without verify)","publickey":"Public Key","template":"Template","blekey":"BLE Key","nfckey":"NFC Key","mininfckey":"Mini NFC Key","defaultperiod":"Default Period(Day)","templatename":"Template Name","delete":"Delete","inputpassword":"Input Password","upgradedongle":"Upgrade Dongle","select":"Select","lastweek":"Last Week","lastmonth":"Last Month","last3month":"Last 3 Months","quickSelect":"Quick Select","disable":"Disable","enable":"Enable","resetpassword":"Reset Password","account":"Account","role":"Role","phone":"Phone Number","email":"Email","disbaled":"Disbaled","administrator":"Administrator","projectoperator":"Project Operator","recordoperator":"Record Operator","billoperator":"Bill Operator","localeoperator":"Locale Operator","productionoperator":"Porduction Operator","qualityoperator":"Quality Operator","unknown":"Unknwon","oldpassword":"Old Password","newpassword":"New Password","confirmpassword":"Confirm New Password","changepassword":"Change Password","loginwhitelist":"Login White List","fixedpublicIP":"Fixed Public IP","add":"Add","report":"Report","eventtype":"Event Type","eventtime":"Event Time","edit":"Edit","login":"Login","projectname":"Project Name","professional":"Professional","enterprise":"Enterprise","createprodongle":"Create Professional Dongle","createentdongle":"Create Enterprise Dongle","register":"Register","logout":"Logout","simplefsu":"Simple FSU","registertime":"Register Time","factory":"Factory","normalfsu":"Normal FSU","oldblekey":"Old Bluetooth Key","blelock":"Bluetooth Lock","terminalType":"Terminal Type","terminalFactory":"Terminal Factory","terminalModel":"Terminal Model","terminalSerialNumber":"Terminal Serial Number","terminalName":"Terminal Name","belongCity":"City","belongCounty":"County","deviceTechnicalManager":"Device Technical Manager","deviceTechnicalManagerPhoneNumber":"Device Technical Manager Phone Number","technicalSupport":"Technical Support","technicalSupportPhoneNumber":"Technical Support Phone Number","bleName":"Bluetooth Name","imei":"IMEI","imsi":"IMSI","edittime":"Edit Time","operator":"Operator","cntt":"CNTT","cmcc":"CMCC","cucc":"CUCC","firstRegisterTime":"First Register Time","use":"Use Audit Trail","bill":"Bill","operation":"Operation","basicInfo":"Basic","siteInfo":"Site","deviceInfo":"Device","picture":"Pictute","sitename":"Site Name","address":"Address","map":"Map","save":"Save","myLocation":"My Location","battery":"Battery","deviceTime":"Device Time","temperature":"Temperature","disarm":"Disarm","deployment":"Deployment","cellId":"Cell ID","cellIP":"Cell IP","port":"Port","rsrq":"RSRQ","sinr":"SINR","networkInfo":"Network Information","gradienter":"Gradienter","waterlogging":"Water Logging","shake":"Shake","armInfo":"Arm Information","normal":"Normal","alarm":"Alarm","deviceName":"Device Name","mask":"Mask","gateway":"Gateway","apn":"APN","password":"Password","dialNumber":"Dial Number","gprsSwitch":"GPRS Switch","server":"Server","mode":"Mode","tcp":"TCP","udp":"UDP","ai":"AI","di":"DI","open":"Open","close":"Close","controlboard":"Control Board","powerboard":"Power Board","expandboard":"Expand Board","changedonglelimit":"Change Limit","userlimit":"User Limit","locklimit":"Lock Limit","backupsetting":"Backup Setting","backupinterval":"Backup Interval","backuptime":"Backup Time","everydayat":"Every Day At","everyweekat":"Every Week At","everymonthat":"Every Month At","lastbackuptime":"Last Backup Time","nextbackuptime":"Next Backup Time","backup":"Backup","recover":"Recover","reset":"Reset","monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday","device":"Device","keytype":"Key Type","slm":"Software License Manager","sdk":"SDK","language":"Language","zhCN":"Chinese","enUS":"English","dateformat":"Date Format","help":"Help","signout":"Sign Out","system":"System","database":"Database","callboard":"Callboard","return":"Return","superadministrator":"Super Administrator","task":"Task","nbpanellock":"NB Panel Lock","onu":"ONU","lid":"LID","alreadyunbind":"Already Unbind","alreadybind":"Already Bind","error":"Error","internaloperator":"Internal Operator","nbiot":"NBIOT","all":"All","takeoffline":"Take Offline","productnumber":"Product Number","chinesename":"Chinese Name","englishname":"English Name","file":"File","lastversion":"Last Version","lastedittime":"Last Edit Time","chinesechangelog":"Chinese Change Log","englishchangelog":"English Change Log","download":"Download","newclock":"New C Lock","hardwareversion":"Hardware Version","softwareversion":"Software Version","producttime":"Product Time","hotspot":"Hotspot","networkmac":"Network Mac","model":"Model","exportkeydata":"Export Key Data","progress":"Progress","newdlock":"New D Lock","backupkeep":"Backup Keep","oneweek":"1 Week","onemonth":"1 Month","threemonth":"3 Months","oneyear":"1 Year","forever":"Forever","doormanagermain":"Door Manager Mainboard","doormanagerreader":"Door Manager Reader","doormanager":"Door Manager","writekeyfactorynumber":"Write Key Factory Number","keyfactorynumber":"Key Factory Number","invoice":"Invoice","invoiceprefix":"Invoice Prefix","invoicecompany":"Invoice Company","price":"Price","date":"Date","consignee":"To Messrs","nameandspecification":"Name of Commodity & Specification","card":"Card","readcard":"Read Card","registercard":"Register Card","createstandalonemanagecard":"Create Standalone Manage Card","createstandalonelogoutcard":"Create Standalone Logout Card","blankruncylinder":"Blank Run Cylinder","createresetcard":"Create Reset Card","cardtype":"Card Type","resetcard":"Reset Card","opencard":"Open Card","blankcard":"Blank Card","settingcard":"Setting Card","constructioncard":"Construction Card","blacklistcard":"Blacklist Card","whitelistcard":"Whitelist Card","agecard":"Age Card","managecard":"Manage Card","logoutcard":"Logout Card","cabinetlock":"Cabinet Lock","restartkey":"Restart Key","sharekey":"Share Key","factoryId":"Factory Number","specified":"Specified","importantparameter":"Important Parameters","encryptedcodes":"Encrypted Codes","plaincodes":"Plain Codes","systemcode":"System Code","locksmithcode":"Lock Smith Code","registercode":"Register Code","iv":"IV","tool":"Tool","encryptanddecrypt":"Encryption-Decryption","algorithm":"Algorithm","defaultpublickey":"Default Public Key","plaintext":"Plain Text","encrypttext":"Encrypt Text","encrypt":"Encrypt","decrypt":"Decrypt","plaintextformat":"Plain Text Format","changelog":"Change Log","fileoperator":"File Operator","title":"Title","content":"Content","haveread":"Read","unread":"Unread","view":"View","keyholdermap":"Key Holder Map","keyholder":"Key Holder","relateddevicecount":"Related Device Count","pincodepanel":"Pincode Panel","keycode":"Key Code","padnumber":"Pad Number","tasktime":"Task Time","upload":"Upload","testnewcdlock":"New C/D Lock For Testing","pincodedlock":"Pincode D Lock","abandon":"Abandon","confirm":"Confirm"},"message":{"savesucceed":"Save successfully.","savefail":"Failed to save.","emptyvalue":"There is something has an empty value.","filetypeerror":"File type error, please choose xlsx file.","registersdkfail":"Failed to register SDK.","upgradedonglefail":"Failed to upgrade dongle.","registersdksucceed":"Register SDK successfully. The version is ","upgradedonglesucceed":"Upgrade dongle successfully.","registersdktimeout":"Register SDK timeout, please check if SDK service is running.","sdkinvalid":"The SDK is invalid, please confrim that you have installed SDK and it is running.","professionaldonglelimit":"Professional dongle's lock count can not be more than 3000.","registerkeysucceed":"Register key successfully.","registerkeyfail":"Failed to regoster key.","logoutkeysucceed":"Logout key successfully.","logoutkeyfail":"Failed to logout key.","createregisterkeysucceed":"Create register key successfully.","createregisterkeyfail":"Failed to register key.","createlogoutkeysucceed":"Create logout key successfully.","createlogoutkeyfail":"Failed to logout key.","createdonglesucceed":"Create dongle successfully.","createdonglefail":"Failed to create dongle.","createblankkeysucceed":"Create blank key successfully.","createblankkeyfail":"Failed to create blank key.","readkeyfail":"Failed to read key.","readdonglefail":"Failed to read dongle.","cleandonglesucceed":"Clean dongle successfully.","cleandonglefail":"Failed to clean dongle.","createlogfail":"Failed to create log.","upgradesdk":"Please upgrade SDK.","createmergencykeyfail":"Failed to create emergency key.","creatversionkeyfail":"Failed to create version key.","createtracekeysucceed":"Create trace key successfully..","createtracekeyfail":"Failed to create trace key.","registerlockfail":"Failed to register lock.","insertlock":"Please insert the lock 1 time.","locknotbelongtoproject":"The lock does not belong to the project.","locknotdefault":"The lock does not default setting.","registerkeyfirstly":"Please register key firstly.","clicknext":"Please click Next.","usesamekey":"Please put the key used at step 1 to the encoder.","readkeyeventfail":"Failed to read key event.","registerlocksucceed":"Register lock successfully.","logoutlockfail":"Failed to logout lock.","logoutlocksucceed":"Logout lock successfully.","createlicensecodesucceed":"Create license code successfully.","createlicensecodefail":"Failed to create license code.","updatelicensecodesucceed":"Update license code successfully.","updatelicensecodefail":"Failed to update license code.","viewlicensecodefail":"Failed to view license code.","viewlicensefail":"Failed to view license.","logoutdonglesucceed":"Logout dongle successfully.","logoutdonglefail":"Failed to logout dongle.","deletesucceed":"Delete successfully.","deletefail":"Failed to delete.","beginlaterthanend":"The activation time can not later than expiry time.","locklimit3000":"Lock count can not be more than 3000.","passworddifferent":"The new passwords are different.","ipinvalid":"The IP is invalid.","newpasswordshoulddifferent":"The new password should different from old password.","parsefail":"Failed to parse.","backupsucceed":"Backup successfully.","backupfail":"Failed to backup.","getbackuplistfail":"Failed to get backup list.","recoversucceed":"Recover successfully.","recoverfail":"Failed to recover.","getbackupsettingfail":"Failed to get backup setting.","changedonglelimitfail":"Failed to change dongle limit.","changedonglelimitsucceed":"Change dongle limit successfully.","plsinputaccount":"Please input account.","plsinputpassword":"Please input Password.","connectserverfail":"Failed to connect to server.","loginfail":"Failed to login.","updateSuccess":"Update successfully.","updateFail":"Failed to update.","useadminkey":"please use programmer key.","imeilengtherror":"The length of IMEI should be 15.","searchfailed":"Failed to search.","cannotfinddevice":"Can not find the device.","takeofflinesucceed":"Unbind device successfully.","takeofflinefailed":"Failed to unbind device.","fileExceed":"The number of file exceed.","chooseuploadfile":"Please choose file to upload.","readkeyeepromfail":"Failed to export key data.","writekeyfactorynumberfail":"Failed to write key factory number.","writekeyfactorynumbersucceed":"Write key factory number successfully.","createinvoicefail":"Failed to create invoice.","readcardsucceed":"Read card successfully.","readcardfail":"Failed to read card.","registercardsucceed":"Register card successfully.","registercardfail":"Failed to register card.","logoutcardsucceed":"Logout card successfully.","logoutcardfail":"Failed to Logout card.","createstandalonemanagecardsucceed":"Create standalone manage card successfully.","createstandalonemanagecardfail":"Failed to create standalone manage card.","createstandalonelogoutcardsucceed":"Create standalone logout card successfully.","createstandalonelogoutcardfail":"Failed to create standalone logout card.","createresetcardsucceed":"Create reset card successfully.","createresetcardfail":"Failed to create reset card.","restartkeysucceed":"Restart key successfully.","restartkeyfail":"Failed to restart key.","countnot0":"The count of user or lock cannot be 0.","encryptsucceed":"Encrypt successfully.","encryptfail":"Failed to encrypt.","decryptsucceed":"Decrypt successfully.","decryptfail":"Failed to decrypt.","keyfactorynumberalreadyexist":"The key's factory number already exists.","getdatafail":"Failed to get data.","createemergencykeysucceed":"Create emergency key successfully.","createemergencykeyfail":"Failed to create emergency key.","passworderror":"Password error.","confirmAbandonKeyHolder":"Are you sure you want to abandon key holder?","abandonFail":"Fail to abandon.","abandonSucceed":"Abandon successfully."}}}

/***/ }),

/***/ "2VMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        accountId: '',
        invoiceEnable: '',
        token: '',
        name: '',
        login: '',
        language: '',
        dateFormat: 0,
        role: 0,
        encoderStatus: '',
        encoderName: '',
        result: {},
        keyeeprom: '',
        callboard: {
            count: 0
        }
    },
    mutations: {
        SET_ACCOUNTID: function SET_ACCOUNTID(state, accountId) {
            state.accountId = accountId;
        },
        SET_INVOICEENABLE: function SET_INVOICEENABLE(state, invoiceEnable) {
            state.invoiceEnable = invoiceEnable;
        },
        SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_NAME: function SET_NAME(state, name) {
            state.name = name;
        },
        SET_LOGIN: function SET_LOGIN(state, login) {
            state.login = login;
        },
        SET_LANGUAGE: function SET_LANGUAGE(state, language) {
            state.language = language;
        },
        SET_DATEFORMAT: function SET_DATEFORMAT(state, dateFormat) {
            state.dateFormat = dateFormat;
        },
        SET_ROLE: function SET_ROLE(state, role) {
            state.role = role;
        },
        SET_ENCODERSTATUS: function SET_ENCODERSTATUS(state, status) {
            state.encoderStatus = status;
        },
        SET_ENCODERNAME: function SET_ENCODERNAME(state, name) {
            state.encoderName = name;
        },
        SET_RESULT: function SET_RESULT(state, result) {
            state.result = result;
        },
        SET_KEYEEPROM: function SET_KEYEEPROM(state, data) {
            state.keyeeprom = data;
        },
        SET_CALLBOARD: function SET_CALLBOARD(state, callboard) {
            state.callboard = callboard;
        }
    }

});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "7W9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49df73e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pjhv");
function injectStyle (ssrContext) {
  __webpack_require__("7W9T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49df73e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MpgJ":
/***/ (function(module, exports) {

module.exports = {
    BASE_API: 'https://www.rayotech.cn/slm/api/v1'
};


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalize_css_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_amap__ = __webpack_require__("/IwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_amap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_store__ = __webpack_require__("2VMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__("Vi3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_function__ = __webpack_require__("lN8z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_function___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__utils_function__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_encoder__ = __webpack_require__("R86V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_invoicepdf__ = __webpack_require__("dK0D");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







 // 默认主题









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_locale_lang_zh_CN___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_amap___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__utils_function___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__utils_invoicepdf__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]({
  messages: {
    'i18n': __webpack_require__("+1Vd")
  }
});

__WEBPACK_IMPORTED_MODULE_8_vue_amap___default.a.initAMapApiLoader({
  // 高德的key
  key: 'af8f94f977f1a15f03ee2984bb124398',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'Geocoder']
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_9__views_store__["a" /* default */].state.token;
  __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.start();
  if (to.path == '/' || to.path == '/login' || to.path == '/factory') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_encoder__["a" /* sdkRelease */])();
    next();
  } else {
    if (token != 'null' && token != null && token != "") {
      // Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      next(); // 如果有token就正常转向
    } else {
      next('/'); // 否则跳转回登录页
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_encoder__["a" /* sdkRelease */])();
    }
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (transition) {
  __WEBPACK_IMPORTED_MODULE_4_nprogress___default.a.done();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__views_store__["a" /* default */],
  i18n: i18n,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ "R86V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export encoderSocket */
/* harmony export (immutable) */ __webpack_exports__["C"] = sdkInit;
/* unused harmony export isJSON */
/* harmony export (immutable) */ __webpack_exports__["a"] = sdkRelease;
/* unused harmony export connectToSdk */
/* unused harmony export connectToSdkWithRSA */
/* unused harmony export initSdk */
/* harmony export (immutable) */ __webpack_exports__["z"] = registerSdk;
/* harmony export (immutable) */ __webpack_exports__["b"] = readCardOfNewCD;
/* harmony export (immutable) */ __webpack_exports__["c"] = registerCardOfNewCD;
/* harmony export (immutable) */ __webpack_exports__["d"] = logoutCardOfNewCD;
/* harmony export (immutable) */ __webpack_exports__["e"] = createManageCardOfNewCD;
/* harmony export (immutable) */ __webpack_exports__["f"] = createLogoutCardOfNewCD;
/* harmony export (immutable) */ __webpack_exports__["g"] = createResetCardOfNewCD;
/* harmony export (immutable) */ __webpack_exports__["h"] = registerKey;
/* harmony export (immutable) */ __webpack_exports__["i"] = logoutKey;
/* harmony export (immutable) */ __webpack_exports__["j"] = logoutKeyWithoutCodes;
/* harmony export (immutable) */ __webpack_exports__["k"] = createRegisterKey;
/* harmony export (immutable) */ __webpack_exports__["l"] = createLogoutKey;
/* harmony export (immutable) */ __webpack_exports__["p"] = createBlankKey;
/* harmony export (immutable) */ __webpack_exports__["n"] = createEmergencyKey;
/* harmony export (immutable) */ __webpack_exports__["o"] = createTraceKey;
/* harmony export (immutable) */ __webpack_exports__["m"] = readKey;
/* harmony export (immutable) */ __webpack_exports__["q"] = readKeyEEPROM;
/* harmony export (immutable) */ __webpack_exports__["r"] = restartKey;
/* harmony export (immutable) */ __webpack_exports__["A"] = writeKeyFactoryNumber;
/* harmony export (immutable) */ __webpack_exports__["y"] = readKeyEvent;
/* harmony export (immutable) */ __webpack_exports__["v"] = upgradeDongle;
/* harmony export (immutable) */ __webpack_exports__["w"] = readDongle;
/* harmony export (immutable) */ __webpack_exports__["s"] = registerDongleV1;
/* harmony export (immutable) */ __webpack_exports__["t"] = registerDongle;
/* harmony export (immutable) */ __webpack_exports__["u"] = logoutDongle;
/* harmony export (immutable) */ __webpack_exports__["x"] = cleanDongle;
/* harmony export (immutable) */ __webpack_exports__["B"] = writeDongleLimit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_store__ = __webpack_require__("2VMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_api__ = __webpack_require__("MpgJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_config_api__);




var encoderSocket = function () {
    var instance = null; //定义初始化_instance

    var Socket = function Socket() {
        return new WebSocket('wss://127.0.0.1:12657');
    };
    return {
        getInstance: function getInstance() {
            if (!instance) {
                instance = new Socket();
            }
            return instance;
        },
        destroy: function destroy() {
            if (instance) {
                instance.close();
                instance = null;
            }
        }
    };
}();

function sdkInit(callback) {
    //process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
    var socket = new encoderSocket.getInstance();
    var eeprom = '';
    var oneLineEEPROM = '';
    socket.onopen = function (event) {
        __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'SDK');
        __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'success');
        console.log('open');
        console.log(event);
        //initSdk();
    };
    socket.onmessage = function (event) {
        console.log('on message');
        console.log(event.data);
        // let content = '';
        // if(true == isJSON(event.data)) {
        //     console.log('isJson');
        //     var obj = JSON.parse(event.data);
        //     console.log(obj.data);       
        //     socket.publicKey = obj.data.code;
        //     console.log(socket.publicKey);
        //     content = event.data;
        // } else if(event.data.length < 16) {
        //     console.log('length < 16');
        //     content = event.data;
        // } else {
        //     console.log('else');
        //     console.log(socket.publicKey);
        //     let socketPublicKey = new NodeRSA(socket.publicKey, 'pkcs1-public');
        //     content = socketPublicKey.decryptPublic(event.data, 'utf8');
        // }
        // console.log(content);

        if (event.data == '@Closed') {
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'Encoder');
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'info');
        } else if (event.data == '@NFCEncoder') {
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'NFC Encoder');
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'warning');
        } else if (event.data == '@BLEEncoder') {
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'BLE Encoder');
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'warning');
        } else if (event.data == '@NFCKey') {
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'NFC Key');
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'success');
        } else if (event.data == '@BLEKey') {
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'BLE Key');
            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'success');
        } else if (event.data.indexOf('@progress') > -1) {
            if (event.data.indexOf('@progress_readkeyeeprom') > -1) {
                var dataList = event.data.split('_');
                var progressList = dataList[2].split('/');
                if (parseInt(progressList[0]) === 0) {
                    __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_KEYEEPROM", '');
                    eeprom = '';
                    oneLineEEPROM = '';
                } else {
                    oneLineEEPROM = oneLineEEPROM + dataList[3];
                    while (oneLineEEPROM.length >= 32) {
                        eeprom = eeprom + oneLineEEPROM.substring(0, 32) + '\n';
                        oneLineEEPROM = oneLineEEPROM.substring(32, oneLineEEPROM.length);
                    }

                    if (parseInt(progressList[0]) === parseInt(progressList[1])) {
                        if (oneLineEEPROM.length > 0) {
                            eeprom = eeprom + oneLineEEPROM;
                        }
                        __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_KEYEEPROM", eeprom);
                    }
                }
            }
        } else {

            //store.commit("SET_RESULT", JSON.parse(content));

            __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_RESULT", JSON.parse(event.data));
        }
    };
    socket.onerror = function (event) {
        console.log('error');
        console.log(event);
    };
    socket.onclose = function (event) {
        __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERNAME", 'SDK');
        __WEBPACK_IMPORTED_MODULE_1__views_store__["a" /* default */].commit("SET_ENCODERSTATUS", 'info');
        console.log('close');
        console.log(event);
    };
}

function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
}

function sdkRelease(callback) {
    encoderSocket.destroy();
}

function connectToSdk(object) {
    var socket = new encoderSocket.getInstance();
    var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(object);
    socket.send(json);
}

function connectToSdkWithRSA(object) {
    var socket = new encoderSocket.getInstance();
    var json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(object);
    //console.log(json);

    // console.log('connectToSdkWithRSA');
    // let socketPublicKey = new NodeRSA(socket.publicKey, 'pkcs1-public-pem');
    // socketPublicKey.setOptions({encryptionScheme: 'pkcs1'});
    // console.log(json);
    // let content = socketPublicKey.encrypt(json, 'base64');
    // console.log(content);
    // socket.send(content);
    socket.send(json);
}

function initSdk() {
    var object = {
        'cmd': 'sdkinit',
        'data': {
            'type': 1
        }
    };

    connectToSdk(object);
}

function registerSdk(id, token, supportkey) {
    var object = {
        'cmd': 'registersdk',
        'data': {
            'type': 'token',
            'duration': 3600,
            'interfaces': ['registerkey', 'logoutkey', 'logoutkeywithoutcodes', 'createregisterkey', 'createlogoutkey', 'createblankkey', 'createemergencykey', 'createtracekey', 'readkey', 'readkeyevent', 'readkeyeeprom', 'restartkey', 'writekeyfactorynumber', 'upgradedongle', 'readdongle', 'registerdongle', 'logoutdongle', 'writedonglelimit', 'readcardofnewcd', 'registercardofnewcd', 'logoutcardofnewcd', 'createmanagecardofnewcd', 'createlogoutcardofnewcd', 'createresetcardofnewcd'],
            'projectid': id,
            'token': token,
            'url': __WEBPACK_IMPORTED_MODULE_2__static_config_api___default.a.BASE_API + '/project/sdk',
            'supportkey': supportkey
        }
    };

    connectToSdkWithRSA(object);
}

function readCardOfNewCD(beep, registerCode, iv) {
    var object = {
        'cmd': 'readcardofnewcd',
        'data': {
            'registercode': registerCode,
            'iv': iv,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function registerCardOfNewCD(cardType, beep, registerCode, iv) {
    var object = {
        'cmd': 'registercardofnewcd',
        'data': {
            'cardtype': cardType,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv
        }
    };

    connectToSdkWithRSA(object);
}

function logoutCardOfNewCD(cardType, beep, registerCode, iv) {
    var object = {
        'cmd': 'logoutcardofnewcd',
        'data': {
            'cardtype': cardType,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv
        }
    };

    connectToSdkWithRSA(object);
}

function createManageCardOfNewCD(cardType, userId, logoutCardUserId, regcodeEnable, beginTime, endTime, beep, registerCode, iv) {
    var object = {
        'cmd': 'createmanagecardofnewcd',
        'data': {
            'cardtype': cardType,
            'userid': userId,
            'logoutcarduserid': logoutCardUserId,
            'regcodeenable': regcodeEnable,
            'begintime': beginTime,
            'endtime': endTime,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv
        }
    };

    connectToSdkWithRSA(object);
}

function createLogoutCardOfNewCD(cardType, userId, manageCardUserId, beginTime, endTime, beep, registerCode, iv) {
    var object = {
        'cmd': 'createlogoutcardofnewcd',
        'data': {
            'cardtype': cardType,
            'userid': userId,
            'managecarduserid': manageCardUserId,
            'begintime': beginTime,
            'endtime': endTime,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv
        }
    };

    connectToSdkWithRSA(object);
}

function createResetCardOfNewCD(cardType, userId, beginTime, endTime, beep, registerCode, iv) {
    var object = {
        'cmd': 'createresetcardofnewcd',
        'data': {
            'cardtype': cardType,
            'userid': userId,
            'begintime': beginTime,
            'endtime': endTime,
            'beep': beep,
            'registercode': registerCode,
            'iv': iv
        }
    };

    connectToSdkWithRSA(object);
}

function registerKey(beep) {
    var object = {
        'cmd': 'registerkey',
        'data': {
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function logoutKey(beep) {
    var object = {
        'cmd': 'logoutkey',
        'data': {
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function logoutKeyWithoutCodes(beep) {
    var object = {
        'cmd': 'logoutkeywithoutcodes',
        'data': {
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function createRegisterKey(beep) {
    var object = {
        'cmd': 'createregisterkey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function createLogoutKey(beep) {
    var object = {
        'cmd': 'createlogoutkey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function createBlankKey(beep) {
    var object = {
        'cmd': 'createblankkey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function createEmergencyKey(beep, begin, end) {
    var object = {
        'cmd': 'createemergencykey',
        'data': {
            'id': 1,
            'activationtime': begin,
            'expirytime': end,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function createTraceKey(beep) {
    var object = {
        'cmd': 'createtracekey',
        'data': {
            'id': 1,
            'beep': beep
        }
    };

    connectToSdkWithRSA(object);
}

function readKey(beep) {
    var object = {
        'cmd': 'readkey',
        'data': {
            'beep': beep,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

function readKeyEEPROM(start, length, beep) {
    var object = {
        'cmd': 'readkeyeeprom',
        'data': {
            'beep': beep,
            'start': start,
            'length': length,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

function restartKey(beep) {
    var object = {
        'cmd': 'restartkey',
        'data': {
            'beep': beep,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

function writeKeyFactoryNumber(factoryNumber, beep) {
    var object = {
        'cmd': 'writekeyfactorynumber',
        'data': {
            'beep': beep,
            'factorynumber': factoryNumber,
            'force': false,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

function readKeyEvent(beep) {
    var object = {
        'cmd': 'readkeyevent',
        'data': {
            'beep': beep,
            'defaultflag': true
        }
    };

    connectToSdkWithRSA(object);
}

function upgradeDongle() {
    var object = {
        'cmd': 'upgradedongle',
        'data': {}
    };

    connectToSdkWithRSA(object);
}

function readDongle() {
    var object = {
        'cmd': 'readdongle',
        'data': {}
    };

    connectToSdkWithRSA(object);
}

function registerDongleV1(type, license, publicEncode) {
    var object = {
        'cmd': 'registerdongle',
        'data': {
            'type': type,
            'license': license,
            'public': publicEncode,
            'version': 1
        }
    };

    connectToSdkWithRSA(object);
}

function registerDongle(type, license, publicEncode, supportkey) {
    var object = {
        'cmd': 'registerdongle',
        'data': {
            'type': type,
            'license': license,
            'public': publicEncode,
            'supportkey': supportkey
        }
    };

    connectToSdkWithRSA(object);
}

function logoutDongle() {
    var object = {
        'cmd': 'logoutdongle',
        'data': {}
    };

    connectToSdkWithRSA(object);
}

function cleanDongle(mac) {
    var object = {
        'cmd': 'writedonglebind',
        'data': {
            'mac': mac
        }
    };

    connectToSdkWithRSA(object);
}

function writeDongleLimit(userlimit, locklimit) {
    var object = {
        'cmd': 'writedonglelimit',
        'data': {
            'userlimit': userlimit,
            'locklimit': locklimit
        }
    };

    connectToSdkWithRSA(object);
}

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YL4E":
/***/ (function(module, exports) {

exports.AccountRoleEnum = {
    ADMINISTRATOR: 1, //管理员
    PROJECT_OPERATOR: 2, //工程操作员
    PRODUCTION_TOOL: 3, //生产工具
    CLIENT: 4, //各客户端
    RECORD_OPERATOR: 5, //记录操作员
    BILL_OPERATOR: 6, //账单操作员
    LOCAL_OPERATOR: 7, //现场操作员
    PRODUCTION_OPERATOR: 8, //生产操作员
    QUALITY_OPERATOR: 9, //品质操作员
    INTERNAL_OPERATOR: 10, //内部操作员
    FILE_OPERATOR: 11 //文件操作员
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    redirect: '/login'
  }, {
    path: '*',
    redirect: '/login'
  }, {
    path: '/login',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ook+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/noaccountconfig',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HPTx")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/home',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cef0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [{
      path: '/account',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sJFS")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/accountdetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XNgX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/database',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nCri")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/device',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tjHP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/system',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A84+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/file',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3FE0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/filedetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("37ZF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/version',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bgnk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/versiondetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aJRP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/callboard',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M2Lu")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/callboarddetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c2bJ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/keyholdermap',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/NEK")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/keyholdermapdetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("S0Qh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/testnewcdlock',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MV4y")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/testnewcdlockdetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3HJg")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/project',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A3YQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/projectdetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HChs")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/projectconfig',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("J7ww")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/projecttemplate',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oHCO")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/projecttemplatedetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T25B")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/accountreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1kRL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/projectreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Xsk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/donglereport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZTr9")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/lockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("etpA")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/keyreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QFhP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/licensecodereport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wPV+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/onureport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZXUI")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/lidreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lOqO")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/nbpanellockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OG5X")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/normalfsureport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hQc+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/powerboardreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("C0sR")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/expandboardreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yp9X")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/blekeyreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j5uY")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/sharekeyreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("p447")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/oldblekeyreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EynQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/newclockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jzbt")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/newdlockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QxJB")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pincodedlockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("36ld")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/blankruncylinderreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OCKr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/cabinetlockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9PCk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/hotspotreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vThW")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/pincodepanelreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ki3d")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/keyholderreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xj1v")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/blelockreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pNN/")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/dongleuse',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+ogA")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/donglebill',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+Bxr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/licensecodebill',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DZO9")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/nbiot',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IwYG")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/encrypt',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IlK9")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/doormanagermainreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pNWw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/doormanagerreaderreport',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2XHb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/invoice',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1tgk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }]
}));

/***/ }),

/***/ "dK0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jspdf__ = __webpack_require__("3h9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.getInvoicePdf = function (title) {
      __WEBPACK_IMPORTED_MODULE_0_html2canvas___default()(document.querySelector('#invoicePdfDom'), {
        allowTaint: true
      }).then(function (canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        var pageHeight = contentWidth / 592.28 * 841.89;
        var leftHeight = contentHeight;
        var position = 0;
        var imgWidth = 595.28;
        var imgHeight = 592.28 / contentWidth * contentHeight;
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        var PDF = new __WEBPACK_IMPORTED_MODULE_1_jspdf__["a" /* default */]('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', (contentWidth - imgWidth) / 2, 60, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + '.pdf');
      });
    };
  }
});

/***/ }),

/***/ "lN8z":
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__("PJh5");
var accountBean = __webpack_require__("YL4E");

exports.install = function (Vue, options) {
    Vue.prototype.getDateFormatString = function (type, isOnlyDate) {
        var formatString = 'yyyy-MM-dd HH:mm:ss';
        if (type == 1 && !isOnlyDate) {
            formatString = "yyyy-MM-dd HH:mm:ss";
        } else if (type == 1 && isOnlyDate) {
            formatString = "yyyy-MM-dd";
        } else if (type == 2 && !isOnlyDate) {
            formatString = "MM-dd-yyyy HH:mm:ss";
        } else if (type == 2 && isOnlyDate) {
            formatString = "MM-dd-yyyy";
        } else if (type == 3 && !isOnlyDate) {
            formatString = "dd-MM-yyyy HH:mm:ss";
        } else if (type == 3 && isOnlyDate) {
            formatString = "dd-MM-yyyy";
        }
        return formatString;
    }, Vue.prototype.dateTimeFormat = function (date, type, isOnlyDate) {
        if (date === null || date === undefined) {
            return "";
        }

        var formatString = 'YYYY-MM-DD HH:mm:ss';
        if (type == 1 && !isOnlyDate) {
            formatString = "YYYY-MM-DD HH:mm:ss";
        } else if (type == 1 && isOnlyDate) {
            formatString = "YYYY-MM-DD";
        } else if (type == 2 && !isOnlyDate) {
            formatString = "MM-DD-YYYY HH:mm:ss";
        } else if (type == 2 && isOnlyDate) {
            formatString = "MM-DD-YYYY";
        } else if (type == 3 && !isOnlyDate) {
            formatString = "DD-MM-YYYY HH:mm:ss";
        } else if (type == 3 && isOnlyDate) {
            formatString = "DD-MM-YYYY";
        }

        return moment(date).format(formatString);
    }, Vue.prototype.getLastSdkVersion = function () {
        return 28;
    };

    Vue.prototype.getSupportKeyList = function (project) {
        var supportKey = [];
        if (project.isBle) {
            supportKey.push('BLE');
        }

        if (project.isNfc) {
            supportKey.push('NFC');
        }

        if (project.isMiniNfc) {
            supportKey.push('MiniNFC');
        }

        return supportKey;
    };

    Vue.prototype.getRoleName = function (account, role) {
        var translate = this.$i18n.messages["i18n"][this.$store.state.language];
        var value = translate.phrase.unknown;
        switch (role) {
            case accountBean.AccountRoleEnum.ADMINISTRATOR:
                if (account === 'admin') {
                    value = translate.phrase.superadministrator;
                } else {
                    value = translate.phrase.administrator;
                }
                break;

            case accountBean.AccountRoleEnum.PROJECT_OPERATOR:
                value = translate.phrase.projectoperator;
                break;

            case accountBean.AccountRoleEnum.RECORD_OPERATOR:
                value = translate.phrase.recordoperator;
                break;

            case accountBean.AccountRoleEnum.BILL_OPERATOR:
                value = translate.phrase.billoperator;
                break;

            case accountBean.AccountRoleEnum.LOCAL_OPERATOR:
                value = translate.phrase.localeoperator;
                break;

            case accountBean.AccountRoleEnum.PRODUCTION_OPERATOR:
                value = translate.phrase.productionoperator;
                break;

            case accountBean.AccountRoleEnum.QUALITY_OPERATOR:
                value = translate.phrase.qualityoperator;
                break;

            case accountBean.AccountRoleEnum.INTERNAL_OPERATOR:
                value = translate.phrase.internaloperator;
                break;

            case accountBean.AccountRoleEnum.FILE_OPERATOR:
                value = translate.phrase.fileoperator;
                break;
        }

        return value;
    };

    Vue.prototype.getCardTypeName = function (type) {
        var translate = this.$i18n.messages["i18n"][this.$store.state.language];
        var name = type;
        switch (type) {
            case 'blankcard':
                name = translate.phrase.blankcard;break;
            case 'opencard':
                name = translate.phrase.opencard;break;
            case 'settingcard':
                name = translate.phrase.settingcard;break;
            case 'constructioncard':
                name = translate.phrase.constructioncard;break;
            case 'resetcard':
                name = translate.phrase.resetcard;break;
            case 'blacklistcard':
                name = translate.phrase.blacklistcard;break;
            case 'whitelistcard':
                name = translate.phrase.whitelistcard;break;
            case 'agecard':
                name = translate.phrase.agecard;break;
            case 'managecard':
                name = translate.phrase.managecard;break;
            case 'logoutcard':
                name = translate.phrase.logoutcard;break;
            default:
                break;
        }

        return name;
    };
};

/***/ }),

/***/ "pjhv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f8f76c6b8e598891c9ba.js